import { Box, Typography, Button, Paper, alpha } from "@mui/material";
import { Divider } from "@mui/material";
import PreUploadTableView from "./PreUploadTableView";
import ReconciliationDisplay from "./ReconciliationDisplay";

const FinalView = ({
  schedule,
  step1Inputs,
  step2Results,
  step2ComputedResults,
  onAddToHPSchedule,
  onReset,
  onCancel,
}) => {
  const handleReset = () => {
    onReset();
  };
  return (
    <Paper
      elevation={0}
      sx={{
        mt: 3,
        p: 3,
        borderRadius: 2,
        bgcolor: (theme) => alpha(theme.palette.primary.main, 0.01),
        border: (theme) =>
          `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
        height: "100%",
      }}
    >
      <Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
          }}
        >
          <Box>
            <Typography variant='h6' fontWeight={600} color='primary.main'>
              Preview Capital Allowance Table
            </Typography>
            <Typography variant='body2' color='text.secondary' sx={{ mt: 0.5 }}>
              Capital allowance breakdown by Year of Assessment
            </Typography>
          </Box>
          <Button
            onClick={handleReset}
            variant='outlined'
            color='secondary'
            size='small'
          >
            Start Over
          </Button>
        </Box>
        <Divider sx={{ mb: 3 }} />
        <PreUploadTableView
          schedule={schedule}
          step2Inputs={step2Results?.inputs}
          step2ComputedResults={step2ComputedResults}
          assetCost={step1Inputs.assetCost}
          computedResults={step2ComputedResults}
          onAddToHPSchedule={onAddToHPSchedule}
          onCancel={onCancel}
        />
      </Box>
    </Paper>
  );
};

export default FinalView;
